/**
 * OpenReplay session replay helpers
 *
 * Project key / ingest point can be overridden via REACT_APP_OPENREPLAY_PROJECT_KEY
 * and REACT_APP_OPENREPLAY_INGEST_POINT in .env.
 * Input values are obscured by default; add the `data-openreplay-obscured`
 * attribute to any element whose text should not be recorded.
 */

import { tracker } from '@openreplay/tracker';

const PROJECT_KEY = process.env.REACT_APP_OPENREPLAY_PROJECT_KEY || 'rbmGTkDCvsva1zcPkij6';
const INGEST_POINT = process.env.REACT_APP_OPENREPLAY_INGEST_POINT || 'https://replay.edulab.in/ingest';

let initialized = false;

export const initSessionReplay = () => {
  if (!PROJECT_KEY || initialized) return;
  tracker.configure({
    projectKey: PROJECT_KEY,
    ingestPoint: INGEST_POINT,
    obscureTextEmails: true,
    obscureInputEmails: true,
  });
  tracker
    .start()
    .then((result) => {
      if (!result || !result.success) {
        console.warn('[OpenReplay] session did not start:', result && result.reason);
      }
    })
    .catch((err) => console.warn('[OpenReplay] failed to start:', err));
  initialized = true;
};

// Tie the session to the logged-in user (id + role only, no name/email)
export const identifySessionUser = (user) => {
  if (!initialized || !user) return;
  if (user.user_id) tracker.setUserID(String(user.user_id));
  if (user.role) tracker.setMetadata('role', user.role);
};
